(() => {
  'use strict';

  const initializeStack = root => {
    if (root.dataset.stackInitialized === 'true') return;
    root.dataset.stackInitialized = 'true';
    const productId = root.dataset.productId;
    const sectionId = root.dataset.sectionId;
    if (!productId || !sectionId || !root.dataset.recommendationsUrl) return;
    let observer;
    let controller;
    let unloaded = false;
    let loading = false;

    const request = async intent => {
      const url = new URL(root.dataset.recommendationsUrl, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      url.searchParams.set('section_id', sectionId);
      url.searchParams.set('product_id', productId);
      url.searchParams.set('limit', '4');
      url.searchParams.set('intent', intent);
      const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetch(url.toString(), { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) return null;
        const html = await response.text();
        if (unloaded) return null;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const returnedRoot = Array.from(documentFragment.querySelectorAll('[data-jmo-stack]')).find(item => item.dataset.sectionId === sectionId);
        const content = returnedRoot?.querySelector('[data-jmo-stack-content]');
        if (!content) return null;
        const seen = new Set([productId]);
        let count = 0;
        content.querySelectorAll('[data-jmo-stack-product-id]').forEach(item => {
          const id = item.dataset.jmoStackProductId;
          if (!id || seen.has(id) || count >= 4 || !item.querySelector('.jmo-product-card a[href]')) item.remove();
          else { seen.add(id); count += 1; }
        });
        if (!count) return null;
        content.querySelectorAll('.jmo-product-card__image').forEach(image => { image.sizes = '(min-width: 990px) 22vw, 46vw'; });
        content.hidden = false;
        return content;
      } catch (_) { return null; }
      finally { window.clearTimeout(timeout); }
    };

    const load = async () => {
      if (loading || unloaded || !root.isConnected) return;
      loading = true;
      observer?.disconnect();
      for (const intent of ['complementary', 'related']) {
        if (unloaded) return;
        const content = await request(intent);
        if (unloaded || !root.isConnected) return;
        if (!content) continue;
        root.replaceChildren(document.importNode(content, true));
        root.dataset.stackIntent = intent;
        root.dataset.stackState = 'loaded';
        return;
      }
      root.dataset.stackState = 'empty';
      root.hidden = true;
    };

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: '600px 0px' });
      observer.observe(root);
    } else load();

    const section = root.closest('.shopify-section');
    section?.addEventListener('shopify:section:unload', () => {
      unloaded = true;
      observer?.disconnect();
      controller?.abort();
    }, { once: true });
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('[data-jmo-stack]')) initializeStack(scope);
    scope.querySelectorAll('[data-jmo-stack]').forEach(initializeStack);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
